module.exports = __webpack_public_path__ + "img/charger-speeds-desktop@2x.eda32b17.png";